import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';

// Register Swiper
register();

const initSliders = () => {
  const swiperContainer =
    document.querySelector<HTMLElement>('.bullets.swiper');

  if (swiperContainer) {
    const nextButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-next',
    );
    const prevButton = swiperContainer.querySelector<HTMLElement>(
      '.custom-button-prev',
    );

    new Swiper(swiperContainer, {
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      slidesPerView: 1.3,
      spaceBetween: 40,
      breakpoints: {
        1024: {
          spaceBetween: 80,
          slidesPerView: 3,
          enabled: false,
        },
      },
    });
  }
};

initSliders();
